/* eslint-disable no-console */
// BonBoZ: báo server trạng thái thông báo đẩy của máy này.
//
// Chặn thông báo trong Cài đặt iPhone hay mất đăng ký push thì trang không
// nhận được sự kiện nào; cách duy nhất để server biết là app tự báo lúc mở và
// mỗi lần quay lại màn hình (lịch gọi: `pushRecovery.js`). Chạy nền: lỗi chỉ
// ghi console, không hiện gì.
import NotificationSubscriptions from '../api/notificationSubscription';
import auth from '../api/auth';
import { getDeviceInfo } from './deviceIdentity';
import { getLastSubscribeError, readPushState } from './pushHelper';

export const REPORT_INTERVAL_MS = 30 * 1000;

let lastReportAt = 0;
// Quyền + có đăng ký của lần báo thành công gần nhất, null khi chưa báo được.
let lastReportedState = null;

// Máy đổi trạng thái so với lần báo trước (vd vừa chặn/bỏ chặn trong Cài đặt):
// chỗ gọi dùng để bỏ qua mốc 30 giây, server biết ngay.
export const hasChangedSinceLastReport = ({ permission, hasSubscription }) =>
  !lastReportedState ||
  lastReportedState.permission !== permission ||
  lastReportedState.hasSubscription !== hasSubscription;

// Trả `true` khi đã gửi được. Bỏ qua nếu lần báo trước (kể cả lần lỗi) chưa
// quá 30 giây, để đổi tab liên tục không dội request lên server. `force` bỏ
// qua mốc này, dùng sau một lần tự đăng ký lại.
export const reportDeviceStatus = async ({ force = false } = {}) => {
  if (!auth.hasAuthCookie()) return false;
  const now = Date.now();
  if (!force && now - lastReportAt < REPORT_INTERVAL_MS) return false;
  lastReportAt = now;

  try {
    const [{ permission, subscription }, deviceInfo] = await Promise.all([
      readPushState(),
      getDeviceInfo(),
    ]);
    await NotificationSubscriptions.reportDeviceStatus({
      ...deviceInfo,
      permission,
      has_subscription: !!subscription,
      endpoint: subscription?.endpoint || null,
      subscribe_error: getLastSubscribeError(),
    });
    lastReportedState = { permission, hasSubscription: !!subscription };
    return true;
  } catch (error) {
    console.warn('Push device status report failed:', error);
    return false;
  }
};
